/* eslint-disable class-methods-use-this */
import Resource from '@/services/resources/common';

export default class DashboardItemTypeResource extends Resource {
  constructor(entrypoint = '/dashboard_items', alias = 'DashboardItem') {
    super(entrypoint, alias);
  }
}
